// extracted by mini-css-extract-plugin
export default {"form-actions":"form-actions","formActions":"form-actions","inside":"inside"};